import React, { useState, ChangeEvent } from 'react';

type TValueTypes = number | string;

interface IEditInputPropTypes {
  value: TValueTypes;
  type: "number" | "text";
  readonly?: boolean;
  onChange: (value: string) => void;
}

export default function EditInput(props: IEditInputPropTypes) {
  const { value, readonly = false, type, onChange } = props;
  const [_value, setValue] = useState<TValueTypes>(value);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const nextValue = e.target.value;
    setValue(nextValue);
    onChange(nextValue);
  };

  if (readonly) {
    return <span>{_value}</span>;
  }
  return <input className="input" type={type} value={_value} onChange={handleChange} />;
}
